// extracted by mini-css-extract-plugin
export var createdDate = "_k1-1";
export var divider = "_k1-2";
export var headerDivider = "_k1-3";
export var messagesCard = "_k1-0";
export var messagesContainer = "_k1-7";
export var messagesContainerWrapper = "_k1-4";
export var pointerCapturingButtonBoxes = "_k1-a";
export var showLeftPanelButton = "_k1-9";
export var showMoreButton = "_k1-c";
export var showMoreButtonContainer = "_k1-b";
export var summaryTitle = "_k1-6";
export var systemMessageCardWrapper = "_k1-d";
export var topButtons = "_k1-8";
export var withPadding = "_k1-5";